import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Container, Grid, Card, CardContent, Typography, Button, Tabs, Tab } from "@mui/material";
import toolsData from "./Toolsdata";
import "./Freetools.css";

const categories = Object.keys(toolsData);

const FreeTools = () => {
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);

  return (
    <Container className="free-tools-container">
      <Typography variant="h4" className="free-tools-title" gutterBottom>
        Free Tools
      </Typography>

      {/* Category Tabs */}
      <Tabs
        value={selectedCategory}
        onChange={(_, newValue) => setSelectedCategory(newValue)}
        centered
        className="free-tools-category-tabs"
        TabIndicatorProps={{ style: { backgroundColor: "#ff6500" } }}
      >
        {categories.map((category) => (
          <Tab key={category} label={category} value={category} className="free-tools-category-tab" />
        ))}
      </Tabs>

      {/* Tools List */}
      <Grid container spacing={3} className="free-tools-grid">
        {toolsData[selectedCategory].map((tool) => (
          <Grid item xs={12} sm={6} md={4} key={tool.name}>
            <Card className="free-tool-card">
              <CardContent className="free-tool-content">

                <Typography variant="body2" className="free-tool-description">{tool.description}</Typography>
                <Button component={Link} to={tool.path} variant="contained" className="free-open-tool-btn">
                {tool.name}
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default FreeTools;